import React, { useContext } from 'react';
import {
      Brand,
      Catalogue,
      HomeCategoryList,
      HomeProductSlider,
      Testimonial,
      WhyUs
} from '../../components/frontend/home';
import MetaContext from '../../stores/MetaContext';

const HomePage = () => {
      const metaCtx = useContext(MetaContext);
      metaCtx.handleSlug('home');

      return (
            <>
                  <HomeCategoryList />
                  <HomeProductSlider />
                  <WhyUs />
                  <Brand />
                  <Testimonial />
                  <Catalogue />
            </>
      );
};
export default HomePage;
